
































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
@Component
export default class PagenationComponent extends Vue {
  @Prop()
  pageCount!: number;

  @Prop({
    default: 0
  })
  allCount!: number;

  @Prop({
    default: 1
  })
  currentPageNo!: number;

  pageNumbersLength: number = 0;

  @Emit()
  changePage(n: number): number {
    return n;
  }

  @Emit()
  moveNextPage(isMove: boolean): boolean {
    return isMove;
  }

  @Emit()
  movePrevPage(isMove: boolean): boolean {
    return isMove;
  }

  get internalCurrentPageNo(): number {
    return this.currentPageNo;
  }

  getPageNumbers(): number[] {
    const res = [
      ...Array(Math.ceil(this.allCount / this.pageCount)).keys()
    ].map(n => n + 1);

    this.pageNumbersLength = res.length;

    return res;
  }

  getItemStartNum(): number {
    return this.allCount === 0
      ? 0
      : (this.internalCurrentPageNo - 1) * this.pageCount + 1;
  }

  getItemEndNum(): number {
    const endNum = this.pageCount * this.internalCurrentPageNo;
    return endNum > this.allCount ? this.allCount : endNum;
  }

  isDisplayPageNumber(n: number, index: number) {
    return (
      n === 1 ||
      this.pageNumbersLength - 1 === index ||
      this.internalCurrentPageNo === n ||
      this.internalCurrentPageNo + 1 === n ||
      this.internalCurrentPageNo - 1 === n
    );
  }

  isPreviousDot(num: number) {
    return (
      this.pageNumbersLength === num &&
      this.internalCurrentPageNo + 1 !== this.pageNumbersLength &&
      this.internalCurrentPageNo + 2 !== this.pageNumbersLength &&
      this.internalCurrentPageNo !== this.pageNumbersLength &&
      this.pageNumbersLength > 3
    );
  }

  isFollowingDot(num: number) {
    return (
      num === 1 &&
      this.internalCurrentPageNo - 1 !== 1 &&
      this.internalCurrentPageNo - 2 !== 1 &&
      this.internalCurrentPageNo !== 1 &&
      this.pageNumbersLength > 3
    );
  }

  isPrevPageDisplay() {
    return this.pageNumbersLength > 1 && this.currentPageNo !== 1;
  }

  isNextPageDisplay() {
    return (
      this.pageNumbersLength > 1 &&
      this.currentPageNo !== this.pageNumbersLength
    );
  }
}
